export class NoDevicePermissionError extends Error{
    constructor(){
        super("Please reset your browser permission");
    }
}